import React from 'react';
import {
    withStyles,
    Typography,
    ListItem,
    Avatar,
    Grid,
    TextField,
    Button,
    ButtonBase,
    IconButton,
} from '@material-ui/core';
import MBack from '../view/MBack';

import DefaultAvatarImg from '../../images/change/default_avatar.png';
import AppData from '../../model/AppData';
import { withRouter } from 'react-router-dom';
import MSnackbar from '../view/MSnackbar';
import TIMUtils from '../../network/TIMUtils';
import DateUtils from '../../control/dateutils';
import MChatModal from '../view/MChatModal';
import ChatUtils from '../../control/ChatUtils';
import { ListView } from 'antd-mobile';
import DeviceEventEmitter, { EventName } from '../../control/event';
import AppUtils from '../../control/apputlis';

const SERVER_AVATAR = require("../../images/change/default_avatar.png");
const ICON_FACE = require("../../images/icons/biaoqing.png");

class PrivateLetter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            messageList: [],
            isCompleted: false,
            nextReqMessageID: '',
            open: false,
            isRefreshing: false,
            conversationList: [],
        };
        console.log('PrivateLetter', props);

        this.ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });


    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'PrivateLetter');
        const { nextReqMessageID } = this.state;
        this.loadHistory(nextReqMessageID);
        DeviceEventEmitter.on(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
        TIMUtils.PRIMSG = [];
        this.getConversation();
        this.setMessageRead();
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
    }

    setMessageRead = () => {
        let { user_id, type } = this.props.match.params;
        let conversationID = '';
        if (type == 'userProfile') {
            conversationID = 'C2C' + user_id;
        } else if (type == 'groupProfile') {
            conversationID = 'GROUP' + user_id;
        }
        if (conversationID.length > 0) {
            TIMUtils.setMessageRead(conversationID);
        }
    }

    getConversation = async () => {
        let result = await TIMUtils.getConversationList();
        console.log(result);
        if (result && result.code == 0 && result.data && result.data.conversationList) {

            let { type, user_id } = this.props.match.params;

            let conversationList = result.data.conversationList.filter((item) => {
                if (type == 'userProfile') {
                    return (item.userProfile != null && item.userProfile != undefined);
                } else if (type == 'groupProfile') {
                    return (item.groupProfile != null && item.groupProfile != undefined);
                }
            })

            if (type == 'userProfile') {
                for (let i = 0; i < conversationList.length; i++) {
                    if (conversationList[i].userProfile.userID == user_id) {
                        // data.nickname = conversationList[i].userProfile.nick;
                        // data.avatar = conversationList[i].userProfile.avatar;
                    }
                }
            } else if (type == 'groupProfile') {
                for (let i = 0; i < conversationList.length; i++) {
                    if (conversationList[i].groupProfile.groupID == user_id) {
                        // data.nickname = conversationList[i].groupProfile.name;
                        // data.avatar = conversationList[i].groupProfile.avatar;
                    }
                }
            }
            this.setState({ conversationList: conversationList })
        }
    }

    onMessageReceived = (event) => {
        console.log('onMessageReceived====>', event);
        const { messageList } = this.state;
        if (event && event.data) {
            for (let i = 0; i < event.data.length; i++) {
                if (TIMUtils.isMessageText(event.data[i].type) || TIMUtils.isMessageImage(event.data[i].type)) {
                    messageList.push(event.data[i]);
                }
            }
        }
        this.setState({ messageList: messageList }, () => {
            if (this.refs.listview) {
                this.refs.listview.scrollTo(0, this.listView.listviewRef.scrollProperties.contentLength);
            }
        });
    }

    loadHistory = async (nextReqMessageID) => {
        let result = null;
        let { type, user_id } = this.props.match.params;
        if (type == 'userProfile') {
            user_id = this._getUserId();
            if (!user_id) return;
            result = await TIMUtils.getC2CHistoryMessageList(user_id, nextReqMessageID, 150);
        } else if (type == 'groupProfile') {
            if (!user_id) return;
            result = await TIMUtils.getGroupHistoryMessageList(user_id, nextReqMessageID, 150);
        }

        console.log('loadHistory', result);
        if (result && result.code == 0) {
            let { messageList } = this.state;
            let msgList = result.data.messageList.reverse();
            for (let i = 0; i < msgList.length; i++) {
                if (!AppData.isOutOfDate(msgList[i].time)) {
                    messageList.push(msgList[i]);
                }
            }
            messageList = messageList.sort((a, b) => {
                return a.time - b.time;
            });
            this.setState({
                messageList: messageList,
                isCompleted: result.data.isCompleted,
                nextReqMessageID: result.data.nextReqMessageID
            }, () => {
                if (this.listView) {
                    this.listView.scrollTo(0, this.listView.listviewRef.scrollProperties.contentLength);
                }
            });
        }
    }



    _sendC2CMessage = (message) => {
        if (message === '') {
            this.toast.show('请输入反馈内容.');
            return;
        }
        let user_id = this._getUserId();
        if (!user_id) return;
        let result = TIMUtils.sendC2CMessage(user_id, message);
        if (result) {
            result.then(res => {
                console.log(res);
                if (res.code == 0) {
                    let { messageList } = this.state;
                    messageList.push(res.data.message);
                    messageList = messageList.sort((a, b) => {
                        return a.time - b.time;
                    });
                    this.setState({ messageList: messageList, message: '' }, () => {
                        if (this.listView) {
                            this.listView.scrollTo(0, this.listView.listviewRef.scrollProperties.contentLength);
                        }
                    });
                }
            })
        }
    }

    _sendGroupMessage = (message) => {
        if (message === '') {
            this.toast.show('请输入反馈内容.');
            return;
        }
        // let user_id = this._getUserId();
        // if (!user_id) return;
        // let data = user_id.split('_');
        // if (data.length == 2) {
        //     user_id = data[1];
        // }

        let { user_id } = this.props.match.params;
        if (!user_id) return;

        let result = TIMUtils.sendGroupMessage(user_id, message);
        if (result) {
            result.then(res => {
                console.log(res);
                if (res.code == 0) {
                    let { messageList } = this.state;
                    messageList.push(res.data.message);
                    messageList = messageList.sort((a, b) => {
                        return a.time - b.time;
                    });
                    this.setState({ messageList: messageList, message: '' }, () => {
                        if (this.listView) {
                            this.listView.scrollTo(0, this.listView.listviewRef.scrollProperties.contentLength);
                        }
                    });
                }
            })
        }
    }

    sendMessage = (message) => {
        let { type } = this.props.match.params;
        if (type == 'userProfile') {
            this._sendC2CMessage(message);
        } else if (type == 'groupProfile') {
            this._sendGroupMessage(message);
        }
    }

    _onSendTextMsg = () => {
        const { message } = this.state;
        this.sendMessage(message);
    }

    _onSendAllMsg = (dom) => {
        let message = '';
        for (let i = 0; i < dom.childNodes.length; i++) {
            let child = dom.childNodes[i];
            if (child.nodeName == 'IMG') {
                message += child.alt;
            } else if (child.nodeName == '#text') {
                message += child.nodeValue;
            }
        }
        this.sendMessage(message);
        this.setState({ open: false });
    }


    isNumber(val) {
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if (regPos.test(val) && regNeg.test(val)) {
            return true;
        } else {
            return false;
        }
    }

    _getUserId = () => {
        let { user_id } = this.props.match.params;
        if (!user_id || user_id == '') {
            return;
        }
        if (typeof (user_id) == 'string' && user_id.startsWith(TIMUtils.getService())) {
            return user_id;
        }

        if (typeof (user_id) == 'string' && user_id.startsWith('host_')) {
            return user_id;
        }

        if (typeof (user_id) == 'string' && user_id.startsWith('tourists_')) {
            return user_id;
        }

        if (typeof (user_id) == 'string' && user_id.startsWith('customer_')) {
            return user_id;
        }


        return TIMUtils.getHostChatId(user_id);
    }

    _handleImageMessage = (images) => {
        let user_id = this._getUserId();
        if (!user_id) return;

        let result = null;
        let { type } = this.props.match.params;
        if (type == 'userProfile') {
            result = TIMUtils.sendImageMessage(user_id, images);
        } else if (type == 'groupProfile') {
            let { user_id } = this.props.match.params;
            result = TIMUtils.sendGroupImageMessage(user_id, images);
        }

        this.setState({ open: false });

        if (result) {
            result.then(res => {
                console.log('_handleImageMessage', res);
                if (res.code == 0) {
                    let { messageList } = this.state;
                    messageList.push(res.data.message);
                    messageList = messageList.sort((a, b) => {
                        return a.time - b.time;
                    });
                    this.setState({ messageList: messageList, message: '' }, () => {
                        if (this.listView) {
                            this.listView.scrollTo(0, 0);
                        }
                    });
                }
            });
        }
    }

    _handleChange = (message) => {
        this.setState({ message: message });
    }

    _showChatPanel = () => {
        this.setState({ open: true });
    }

    _handleClose = () => {
        console.log('_handleClose');
        this.setState({ open: false });
    }

    getImageInfo(msg) {
        let url = '';
        let width = 0;
        let height = 0;
        if (TIMUtils.isMessageImage(msg.type)) {
            if (msg.payload && msg.payload.imageInfoArray && msg.payload.imageInfoArray.length > 0) {
                for (let i = 0; i < msg.payload.imageInfoArray.length; i++) {
                    url = msg.payload.imageInfoArray[i].url;
                    if (msg.payload.imageInfoArray[i].width != 0) {
                        width = msg.payload.imageInfoArray[i].width;
                    }
                    if (msg.payload.imageInfoArray[i].height != 0) {
                        height = msg.payload.imageInfoArray[i].height;
                    }
                }
            }
        }
        return { url: url, width: width, height: height };
    }

    _renderRight(i, avatar, msg) {
        const { classes } = this.props;
        let obj = this.getImageInfo(msg);
        return (
            <ListItem key={'right_' + i} style={{ alignItems: 'flex-start', paddingLeft: 8, paddingRight: 8 }}>
                <Avatar className={classes.avatar} src={avatar} />
                {
                    TIMUtils.isMessageText(msg.type) && <div className={classes.rightp}>
                        {
                            ChatUtils.createHtml(msg.payload.text)
                        }
                    </div>
                }
                {
                    TIMUtils.isMessageImage(msg.type) && <Grid style={{ marginLeft: 8, marginRight: 8 }}>
                        <img src={obj.url} height={obj.height} width={obj.width} style={{ maxWidth: '100%', height: 'auto', objectFit: 'scale-down' }}></img>
                    </Grid>
                }
            </ListItem>
        );
    }

    _renderLeft(i, avatar, msg) {
        const { classes } = this.props;
        let obj = this.getImageInfo(msg);
        return (
            <ListItem key={'left_' + i} style={{ alignItems: 'flex-start', justifyContent: 'flex-end', paddingLeft: 8, paddingRight: 8 }}>
                {
                    TIMUtils.isMessageText(msg.type) && <div className={classes.leftp}>
                        {
                            ChatUtils.createHtml(msg.payload.text)
                        }
                    </div>
                }
                {
                    TIMUtils.isMessageImage(msg.type) && <Grid style={{ marginLeft: 8, marginRight: 8 }}>
                        <img src={obj.url} height={obj.height} width={obj.width} style={{ maxWidth: '100%', height: 'auto', objectFit: 'scale-down' }}></img>
                    </Grid>
                }
                <Avatar className={classes.avatar} src={avatar} />
            </ListItem>
        );
    }

    _renderTips(i, msg) {
        return (
            <ListItem
                key={'tips_' + i}
                style={{ alignItems: 'flex-start', justifyContent: 'center', paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}>
                <Typography style={{ color: '#878787', fontSize: 11 }}>{msg}</Typography>
            </ListItem>
        );
    }



    _renderByType(item, i) {

        if (item.payload.data && item.payload.data == 'group_create') {
            return this._renderTips(i, "host_1创建群组");
        } else if (item.payload.operationType == 3) {
            let str = '';
            if (item.payload.userIDList) {
                str = item.payload.userIDList.join(',');
            }
            return this._renderTips(i, "\"" + str + "\"" + "被踢出群组");
        } else if (item.payload.operationType == 2) {
            let str = '';
            if (item.payload.userIDList) {
                str = item.payload.userIDList.join(',');
            }
            return this._renderTips(i, "\"" + str + "\"" + "退出群组");
        } else if (item.payload.operationType == 1) {
            let str = '';
            if (item.payload.userIDList) {
                str = item.payload.userIDList.join(',');
            }
            return this._renderTips(i, "\"" + str + "\"" + "被邀请进群");
        }



        let isMe = item.from == AppData.me.identifier;
        if (!isMe) {
            let pic = SERVER_AVATAR;
            // 隐藏主播头像 
            let { type } = this.props.match.params;
            if (type == 'groupProfile') {
                pic = item.avatar;
            }
            return (
                <Grid key={i} container direction='column' alignItems='center'>
                    {
                        this._renderTips(i, DateUtils.dateFormatMDHM(item.time))
                    }
                    {
                        this._renderRight(i, pic, item)
                    }
                </Grid>
            );
        } else {
            return (<Grid key={i} container direction='column' alignItems='center'>
                {
                    this._renderTips(i, DateUtils.dateFormatMDHM(item.time))
                }
                {
                    this._renderLeft(i, AppData.me.Pic, item)
                }
            </Grid>);
        }
    }


    _onRefresh = () => {
        const { isCompleted, nextReqMessageID } = this.state;
        console.log('_onRefresh', isCompleted, nextReqMessageID);
        if (!isCompleted) {
            this.loadHistory(nextReqMessageID);
        }
    }

    _onEndReached = () => {

    }

    _renderFooter = () => {

    }

    _renderHeader = () => {
        return (<Grid style={{ height: 16 }}></Grid>)
    }

    _renderItem = (data, sectionID, rowID) => {
        return this._renderByType(data, rowID);
    }



    render() {
        const { messageList, message, open } = this.state;
        const { classes } = this.props;
        let nickname = this.props.location.data;

        let title = '通讯';
        if (!nickname || nickname.length == 0) {
            if (AppData.ServerConfig && AppData.ServerConfig.tap_show == 1) {
                title = '我的通讯';
            }
        } else {
            title = nickname;
        }

        console.log('messageList', messageList);

        return (
            <MBack title={title} backgroundColor='#F7F7F7'>
                <ListView
                    initialListSize={messageList.length}
                    listPrefixCls='padding: 0px'
                    style={{ width: '100vw', minHeight: 'calc(100vh - 112px)', maxWidth: '100%', padding: 0, paddingTop: 8 }}
                    contentContainerStyle={{ width: '100%', padding: 0, height: '100%' }}
                    dataSource={this.ds.cloneWithRows(messageList)}
                    renderRow={this._renderItem}
                    pageSize={10}
                    useBodyScroll={false}
                    renderHeader={this._renderHeader}
                    onEndReached={this._onEndReached}
                    onEndReachedThreshold={10}
                    // pullToRefresh={
                    //     <PullToRefresh
                    //         refreshing={isRefreshing}
                    //         onRefresh={this._onRefresh}
                    //     />
                    // }
                    ref={el => this.listView = el}
                    renderFooter={this._renderFooter}
                >
                </ListView>
                <Grid container direction='row' alignItems='center' justify='space-between' style={{ backgroundColor: '#FFF', height: 55, position: 'fixed', bottom: 0 }}>
                    <Grid container direction='row' alignItems='center' justify='space-between' className={classes.inputBack}>
                        <input value={message} onChange={(e) => this._handleChange(e.target.value)} className={classes.input} placeholder='您如何看待这场球...'></input>
                        <IconButton onClick={() => this._showChatPanel()} className={classes.iconButton}>
                            <img src={ICON_FACE} style={{ width: 20, height: 20 }}></img>
                        </IconButton>
                    </Grid>
                    <Grid container direction='row' justify='flex-end' style={{ maxWidth: 70 }}>
                        <ButtonBase onClick={() => this._onSendTextMsg()} className={classes.sendMsg}>发送</ButtonBase>
                    </Grid>
                </Grid>
                <MChatModal
                    open={open}
                    isFile={true}
                    onClose={() => this._handleClose()}
                    sendImageMessage={(images) => this._handleImageMessage(images)}
                    onSendMsg={(val) => this._onSendAllMsg(val)} />
                <MSnackbar ref={(ref) => { this.toast = ref }} />
            </MBack >
        );
    }
}
export default withRouter(withStyles((theme) => ({
    avatar: {
        width: 50,
        height: 50,
        color: '#fff',
        marginTop: 0,
        backgroundSize: 'cover',
        backgroundImage: `url(${DefaultAvatarImg})`,
    },
    rightp: {
        color: '#0D0D0D',
        backgroundColor: '#fff',
        padding: theme.spacing(0.5, 1, 0.5, 1),
        borderRadius: 5,
        margin: theme.spacing(0.2, 1, 0.2, 1),
        fontSize: theme.typography.pxToRem(13),
        maxWidth: 'calc(100% - 132px)'
    },
    leftp: {
        color: '#FC3035',
        backgroundColor: '#FDEAEB',
        border: '0px solid #E2E2E2',
        padding: theme.spacing(0.5, 1, 0.5, 1),
        borderRadius: 5,
        margin: theme.spacing(0.2, 1, 1, 1),
        fontSize: theme.typography.pxToRem(13),
        maxWidth: 'calc(100% - 132px)'
    },
    payBtn: {
        background: '#F82A5C',
        borderRadius: 14.5,
        color: 'white',
        height: 29,
        width: 65,
        fontSize: theme.typography.pxToRem(13),
        position: 'absolute',
        right: 10,
        marginRight: 10,
        fontWeight: theme.typography.fontWeightBold,
    },
    textfield: {
        backgroundColor: '#F0F0F0',
        fontSize: 13,
        height: 35,
        marginLeft: 30,
        borderRadius: 5,
        width: '60%',
        justifyContent: 'flex-end',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(0.2, 1, 0.2, 1),
    },
    inputBack: {
        backgroundColor: '#EDEDED',
        borderRadius: 17.5,
        height: 35,
        flex: 1,
        marginLeft: 8,
        marginRight: 8,
    },
    input: {
        outline: 'none',
        border: 0,
        marginLeft: 16,
        backgroundColor: 'transparent',
        height: 35,
        flex: 1,
        fontSize: 12,
    },
    sendMsg: {
        backgroundColor: '#0D0D0D',
        color: '#FFF',
        fontSize: 14,
        height: 35,
        width: 70,
        borderRadius: 17.5,
        marginRight: 8,
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        width: 20,
        height: 20,
        marginRight: 8
    },
}))(PrivateLetter));
